module.exports = {
  'config_name':'default_config',
  'type':'VSAAS',
  'config_details': {
    'protectionType':'clear',
    'onvifPort':'80',
    'rtspPort':'554',
    'detection':'auto',
    'e2c_server_address':'ewc-preprod.edgeway.io',
    'e2c_server_port':'443',
    'e2c_server_enable_ssl':'true',
    'e2c_server_websocket_path':'/ws',
    'ewi_lab_server_address':'ewi-preprod.edgeway.io',
    'ewi_lab_server_port':'5556',
    'ewi_liveview_quiet':'true',
    'test_mode':'A',
    'test_timeout':'300'
  }
}